/**
 * This is our clientside javascript entry point
 */

// The Ceres bundle provides Vue, we do not need to bundle it ourself

const Vue = window.Vue;

$(document).on('change','.chkbox-filter',function(){
    //var queryUrl = $('[data-eg-facets]').data('eg-queryurl')
    var $cardWrap = $(this).closest('.card');
    $('.btn-filter-facet').removeClass('show-filter-btn');
    var facetIds = [];
    $('.chkbox-filter:checked').each(function(index){

        facetIds.push($(this).data('eg-facetvalueid'));
    });
    

    var priceMin = isNaN($('#priceRangeMin').val()) ? 0 : $('#priceRangeMin').val();
    var priceMax = isNaN($('#priceRangeMax').val()) ? 0 : $('#priceRangeMax').val();
    /*if($(_this).hasClass('facet-remove-price')){
        priceMin = 0;
        priceMax = 0;
        $('.facet-input-price-min').val('');
        $('.facet-input-price-max').val('');
    }*/

    var searchParams = {
        //items: $('[data-eg-facets]').data('eg-defaultitemsperpage'),
        sorting: ceresStore.state.itemList.sorting,
        query: ceresStore.state.itemList.searchString,
        facets: facetIds.join(','),
        priceMin: priceMin,
        priceMax: priceMax,
        categoryId: ceresStore.state.navigation.currentCategory.id
    }
    $cardWrap.addClass('show-filter-btn');
    
    
    //$(_this).closest('.eg-dropdown-content').addClass('isLoading');
    if($('.forRemove').length>0){
        $('.forRemove').remove()
    }
    $cardWrap.addClass('is-loading');
    $.ajax({
        url: "/rest/io/facet/",
        method: "GET",
        data: searchParams,
        dataType: "JSON"
    }).done(function( response ) {
        console.log(response)
        $('.form-check').attr('data-facetcount',0)
        $(response.data.facets).each(function(i, facetGroup){
            $(facetGroup.values).each(function(i, facetValue){
                $('.form-check[data-facetvalue="'+facetValue.id+'"]').attr('data-facetcount',facetValue.count)
                $('.form-check[data-facetvalue="'+facetValue.id+'"]').find('.filter-badge').html(facetValue.count)
            })
        });

        $('.btn-filter-facet .items-filter-found').html(response.data.itemList.total);


        var facetUrl = "";
        var urlParam = {};
        var priceUrl = "";
        if(priceMin>0 || priceMax>0){
            urlParam["priceMin"] = priceMin;
            urlParam["priceMax"] = priceMax;
        }
        if(ceresStore.state.itemList.searchString != undefined){
            urlParam["query"] = ceresStore.state.itemList.searchString;
        }
        if($cardWrap.find('.chkbox-filter:checked').length>0){
            urlParam["facets"] = facetIds.join(',')
        }
        if(ceresStore.state.itemList.sorting != 'variation.createdAt_desc'){
            urlParam["sorting"] = ceresStore.state.itemList.sorting;
        }
        var targetSearchUrl = ""
        if($.param(urlParam)!=""){
            targetSearchUrl = window.location.pathname+'?'+$.param(urlParam);
        }else{
            targetSearchUrl = window.location.pathname
        }
        $('.btn-filter-facet').attr('onclick',"document.location.href='"+targetSearchUrl+"'");
        //$(_this).closest('.eg-dropdown-content').removeClass('isLoading');
        $cardWrap.removeClass('is-loading');
        /*
        if($(_this).hasClass('pricefilter')){
            document.location.href = targetSearchUrl;
        }*/
    });
    
})

$(document).on('click','.facet-clickable-title',function(){
    $(this).closest('.card').toggleClass('is-open')
})
$(document).on('click','.btn-open-filter-mobile',function(){
    $('.filter-main-wrap').toggleClass('is-open')
})

Vue.component("PriceRangeSlider", {
    template: `
    <div class="track-container">
        <div class="track" ref="_vpcTrack"></div>
        <div class="track-highlight" ref="trackHighlight" @click="onClick"></div>
        <button class="track-btn track1" ref="track1"
            @click="onClick" @touchend="touchend($event, 'track1')" @touchmove="touchmove($event, 'track1')"
            @touchstart="touchstart($event, 'track1')" @mousemove="mousemove($event, 'track1')"
            @mousedown="mousedown($event, 'track1')" @mouseup="mouseup($event, 'track1')">
        </button>
        <button class="track-btn track2" ref="track2"
            @click="onClick" @touchend="touchend($event, 'track2')" @touchmove="touchmove($event, 'track2')"
            @touchstart="touchstart($event, 'track2')" @mousemove="mousemove($event, 'track2')"
            @mousedown="mousedown($event, 'track2')" @mouseup="mouseup($event, 'track2')">
        </button>
    </div>
    `,
    props: {
        initialMinValue   : {
            type: Number, default: 0
        }, initialMaxValue: {
            type: Number, default: lastPrice
        },
    },

    data() {
        return {
            min: 0,
            minValue: 0,
            maxValue: lastPrice,
            max: lastPrice,
            step: 10,
            totalSteps: 0,
            percentPerStep: 1,
            trackWidth: null,
            isDragging: false,
            pos: {curTrack: null}
        }
    },
    watch: {
        initialMinValue(val) {
            if (val <= this.max && val >= this.min && val < this.maxValue) {
                this.minValue = parseInt(val);
                this.revertMoveTrack('track1');
            } else if (val < this.min) {
                this.minValue = this.min;
                this.revertMoveTrack('track1');
            }
        },
        initialMaxValue(val) {
            if (val <= this.max && val >= this.min && val > this.minValue) {
                this.maxValue = parseInt(val);
                this.revertMoveTrack('track2');
            } else if (val > this.max) {
                this.maxValue = this.max;
                this.revertMoveTrack('track2');
            }
        }
    },
    methods: {
        revertMoveTrack(track) {
            if (track === 'track2') {
             
                if(this.max > this.maxValue){
                    this.maxValue = this.max;
                }
                const percent = 100 / this.max * this.maxValue;
                this.$refs.track2.style.left = percent + '%';
            } else if (track === 'track1') {
                const percent = 100 / this.max * this.minValue;
                this.$refs.track1.style.left = percent + '%';
            }
            this.setTrackHightlight();
        },
        moveTrack(track, ev) {

            let percentInPx = this.getPercentInPx();

            let trackX = Math.round(this.$refs._vpcTrack.getBoundingClientRect().left);
            let clientX = ev.clientX;
            let moveDiff = clientX - trackX;

            let moveInPct = moveDiff / percentInPx

            // if (moveInPct > 100) return;
            let value = 0;
            if (moveInPct < 1) {
                value = 0;
            } else if (moveInPct > 100) {
                value = this.max;
            } else {
                value = (Math.round(moveInPct / this.percentPerStep) * this.step) + this.min;
            }

            if (track === 'track1') {
                if (value >= (this.maxValue - this.step
                )) return;
                this.minValue = value;
            }

            if (track === 'track2') {
                if (value <= (this.minValue + this.step
                )) return;
                this.maxValue = value;
            }
            if (moveInPct > 0 && moveInPct <= 100) {
                this.$refs[track].style.left = moveInPct + '%';
                this.setTrackHightlight();
            }
            this.$emit('slider-change', {minValue: this.minValue, maxValue: this.maxValue, isDragging: this.isDragging})

        }, mousedown(ev, track) {
            if (this.isDragging) return;
            this.isDragging = true;
            this.pos.curTrack = track;
        },

        touchstart(ev, track) {
            this.mousedown(ev, track)
        },

        mouseup(ev, track) {
            if (!this.isDragging) return;
            this.isDragging = false
        },

        touchend(ev, track) {
            this.mouseup(ev, track)
        },

        mousemove(ev, track) {
            if (!this.isDragging) return;
            this.moveTrack(track, ev)
        },

        touchmove(ev, track) {
            this.mousemove(ev.changedTouches[0], track)
        },

        valueToPercent(value) {
            return ((value - this.min
                ) / this.step
            ) * this.percentPerStep
        },

        setTrackHightlight() {
            var percentMaxLeft = this.valueToPercent(this.minValue);
            var percentMax = this.valueToPercent(this.maxValue) - this.valueToPercent(this.minValue);
            if(percentMax > 100){
                percentMax = 100;
            }
            this.$refs.trackHighlight.style.left = this.valueToPercent(this.minValue) + '%'
            this.$refs.trackHighlight.style.width = percentMax + '%'
        },

        getPercentInPx() {
            let trackWidth = this.$refs._vpcTrack.offsetWidth;
            let oneStepInPx = trackWidth / this.totalSteps;
            let percentInPx = oneStepInPx / this.percentPerStep;

            return percentInPx;
        },

        setClickMove(ev) {
            let track1Left = this.$refs.track1.getBoundingClientRect().left;
            let track2Left = this.$refs.track2.getBoundingClientRect().left;
            if (ev.clientX < track1Left) {
                this.moveTrack('track1', ev)
            } else if ((ev.clientX - track1Left
            ) < (track2Left - ev.clientX
            )) {
                this.moveTrack('track1', ev)
            } else {
                this.moveTrack('track2', ev)
            }
        }, onClick(ev) {
            ev.stopPropagation();
            this.setClickMove(ev)
        },
    },

    mounted() {// calc per step value
        this.minValue = this.initialMinValue;
        this.maxValue = this.initialMaxValue;
        this.totalSteps = (this.max - this.min
        ) / this.step;
        this.percentPerStep = 100 / this.totalSteps;
        this.$refs.track1.style.left = this.valueToPercent(this.minValue) + '%';
        var maxLeft = this.valueToPercent(this.maxValue);
        if(maxLeft > 100){
            maxLeft = 100;
        }
        this.$refs.track2.style.left = maxLeft + '%'
        this.setTrackHightlight();

        var self = this;

        ['mouseup', 'mousemove'].forEach(type => {
            document.body.addEventListener(type, (ev) => {// ev.preventDefault();
                if (self.isDragging && self.pos.curTrack) {
                    self[type](ev, self.pos.curTrack)
                }
            })
        });
    }
    });